module.exports = __webpack_public_path__ + "static/media/scoutPlayerProfile.d2b71133.png";